import { ServiceClient } from '@johnlewispartnership/wtr-website-api-client';
import config from 'config';
import { logger } from 'logger';
import { withApiBaseUrl } from 'services/utils/with-api-base-url';

type MembershipResponse = {
  type: string;
  number: string;
}[];

export const MY_WAITROSE_MEMBERSHIP = 'mywaitrose';

const BASE_URL = withApiBaseUrl(config.services.memberships.path);
class MembershipService extends ServiceClient {
  async getMembershipNumber(authHeader: string) {
    const membershipUrl = '/memberships';

    const response = await this.httpClient.get(membershipUrl, {
      headers: {
        Authorization: authHeader,
        breadcrumb: config.applicationName,
      },
    });

    const correlationId = response.headers?.['wtr-correlation-id'];

    if (response.error) {
      const message = `Failed to fetch membership: ${response.error.message}`;
      logger.error({
        payload: {
          message,
          correlationId,
          httpStatus: String(response.status),
          duration: response.duration,
          service: 'memberships',
          url: `${BASE_URL}${membershipUrl}`,
        },
      });

      return Promise.reject(response);
    }

    logger.info({
      payload: {
        message: 'Fetched membership',
        correlationId,
        httpStatus: String(response.status),
        duration: response.duration,
        service: 'memberships',
        url: `${BASE_URL}${membershipUrl}`,
      },
    });

    const membershipData: MembershipResponse = response.data;

    return membershipData.find(member => member.type === MY_WAITROSE_MEMBERSHIP)?.number;
  }
}

export default new MembershipService(BASE_URL);
